import canadaposticon from '~/assets/canadaposticon.svg';
import dhlicon from '~/assets/dhlicon.svg';
import fedexicon from '~/assets/fedexicon.svg';
import purolatoricon from '~/assets/purolatoricon.svg';
import upsicon from '~/assets/upsicon.svg';

export function carrierGroupFromCode(code) {
  const normalized = String(code || '')
    .trim()
    .toLowerCase()
    .replace(/[_-]+/g, ' ')
    .replace(/\s+/g, ' ');

  if (normalized.includes('dhl')) return 'dhl';
  if (normalized.includes('fedex')) return 'fedex';
  if (normalized.includes('ups')) return 'ups';
  if (normalized.includes('usps')) return 'usps';
  if (normalized.includes('purolator')) return 'purolator';
  if (normalized.includes('canada post')) return 'canada_post';
  if (normalized.includes('amazon')) return 'amazon';
  if (normalized.includes('paquete')) return 'paquete_express';
  if (normalized === 'other') return 'other';

  return 'other';
}

export function getCarrierIcon(carrierCode) {
  const group = carrierGroupFromCode(carrierCode);
  const icons = {
    ups: upsicon,
    fedex: fedexicon,
    purolator: purolatoricon,
    dhl: dhlicon,
    canada_post: canadaposticon,
  };
  return icons[group] || null;
}
